import React, { Fragment, useState } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody, Input } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import SubscriptionTable from "../PageComponents/SubscriptionTable";
import SubscriptionAnalytics from "../PageComponents/SubscriptionAnalytics.jsx"
import { subscriberData } from "../PageComponents/index";

const ViewSubscribers = () => {
  const [filter, setFilter] = useState("");

  // Filter subscribers based on status
  const filteredSubscribers =
    filter === "" ? subscriberData : subscriberData.filter((sub) => sub.paymentStatus === filter);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="View Subscriptions" parent="Subscription Management" title="Subscription History & Revenue" />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <SubscriptionTable data={filteredSubscribers} type="subscribers" />
          </Col>
          <Col xl="12">
            <SubscriptionAnalytics />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ViewSubscribers;
